import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import bannerSlideOne from '../../../../client_customizations/assets/images/banner-slide-1.jpg';
import bannerSlideTwo from '../../../../client_customizations/assets/images/banner-slide-2.jpg';
import bannerSlideThree from '../../../../client_customizations/assets/images/banner-slide-3.jpg';
import bannerSlideFour from '../../../../client_customizations/assets/images/banner-slide-4.jpg';
import { FormattedMessage } from 'react-intl';
import './ERidesBigPromise.scss';

const ERidesBigPromise = ({ eRidesBannerImage }) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'linear',
    pauseOnHover: true,
    arrows: true,
  };

  const bannerImages = [
    bannerSlideOne,
    bannerSlideTwo,
    bannerSlideThree,
    bannerSlideFour,
  ];

  return (
    <section
      className="container"
      aria-label="ERides Big Promise"
      id="erides-big-promise"
    >
      <div className="big-promise" style={{ position: 'relative' }}>
        <Slider {...sliderSettings} className="big-promise-slider">
          {bannerImages.map((image, index) => (
            <div key={index}>
              <img
                src={image}
                alt={`Banner slide ${index + 1}`}
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                }}
              />
            </div>
          ))}
        </Slider>
        <div className="big-promise-title">
          <h1>
            <FormattedMessage
              id="erides.bigPromise.title"
              defaultMessage="Save Money. Ride Electric."
            />
          </h1>
          <p>
            <FormattedMessage
              id="erides.bigPromise.description"
              defaultMessage="Austin Energy offers rebates to help you purchase eligible electric bikes, scooters, mopeds, and other two- or three-wheel electric vehicles."
            />
          </p>
        </div>
      </div>
    </section>
  );
};

export default ERidesBigPromise;

ERidesBigPromise.propTypes = {
  eRidesBannerImage: PropTypes.string,
};
